import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ExternalLinkManagerComponent } from "./external-link-manager.component";

@NgModule({
  imports: [ExternalLinkManagerComponent, CommonModule],
  exports: [ExternalLinkManagerComponent],
})
export class ExternalLinkManagerModule {}
